<template>
  <div>
    <!--BET SPREAD-->
    <my-position-spreads
      v-if="showsMarket('spread')"
      :spread-away="spreadAway"
      :spread-home="spreadHome"
      :avg-odds-spreads="avgOddsSpreads"
      :spread-risk="spreadRisk"
      :avg-odds-money-line="avgOddsMoneyLine"
      :grouped-bets="groupedBets"
      :league="league"
      :game="game"
    />

    <!--BET MONEYLINE-->
    <my-position-money-lines
      v-if="showsMarket('moneyline')"
      :money-line-away="moneyLineAway"
      :money-line-home="moneyLineHome"
      :money-line-home-risk-win="moneyLineHomeRiskWin"
      :avg-odds-money-line="avgOddsMoneyLine"
      :money-line-away-risk-win="moneyLineAwayRiskWin"
      :moneyline-risk="moneylineRisk"
      :grouped-bets="groupedBets"
      :league="league"
      :game="game"
    />

    <!--BET TOTAL-->
    <my-position-totals
      v-if="showsMarket('total')"
      :total-under="totalUnder"
      :total-over="totalOver"
      :avg-odds-totals="avgOddsTotal"
      :total-risk="totalRisk"
      :grouped-bets="groupedBets"
      :league="league"
      :game="game"
    />

    <!--BET MONEYLINE1X2-->
    <my-position-money-lines-1x2
      v-if="showsMarket('moneyline1x2')"
      :money-line-1x2-away-yes="moneyLine1x2AwayYes"
      :money-line-1x2-away-no="moneyLine1x2AwayNo"
      :money-line-1x2-home-yes="moneyLine1x2HomeYes"
      :money-line-1x2-home-no="moneyLine1x2HomeNo"
      :money-line-1x2-draw-yes="moneyLine1x2DrawYes"
      :money-line-1x2-draw-no="moneyLine1x2DrawNo"
      :money-line-1x2-away-yes-risk-win="moneyLine1x2AwayYesRiskWin"
      :money-line-1x2-away-no-risk-win="moneyLine1x2AwayNoRiskWin"
      :money-line-1x2-home-yes-risk-win="moneyLine1x2HomeYesRiskWin"
      :money-line-1x2-home-no-risk-win="moneyLine1x2HomeNoRiskWin"
      :money-line-1x2-draw-yes-risk-win="moneyLine1x2DrawYesRiskWin"
      :money-line-1x2-draw-no-risk-win="moneyLine1x2DrawNoRiskWin"
      :avg-odds-money-line-1x2="avgOddsMoneyLine1x2"
      :moneyline-1x2-risk="moneyline1x2Risk"
      :grouped-bets="groupedBets"
      :league="league"
      :game="game"
    />
  </div>
</template>

<script setup>
//COMPONENTS
import MyPositionSpreads from '@/components/userBets/myPosition/MyPositionSpreads.vue';
import MyPositionMoneyLines from '@/components/userBets/myPosition/MyPositionMoneyLines.vue';
import MyPositionTotals from '@/components/userBets/myPosition/MyPositionTotals.vue';
import MyPositionMoneyLines1x2 from '@/components/userBets/myPosition/MyPositionMoneyLines1x2.vue';

//PROPS
const props = defineProps({
  game: {
    type: Object,
    default: null,
  },
  // When set, only this market's section renders — clicking the position badge
  // on an Over 9.5 cell shouldn't surface the moneyline bets on the same game.
  betType: {
    type: String,
    default: '',
  },
  moneyLineAway: {
    type: Array,
    required: true,
  },
  moneyLineHome: {
    type: Array,
    required: true,
  },
  totalUnder: {
    type: Object,
    required: true,
  },
  totalOver: {
    type: Object,
    required: true,
  },
  spreadAway: {
    type: Object,
    required: true,
  },
  spreadHome: {
    type: Object,
    required: true,
  },
  moneyLine1x2AwayYes: {
    type: Array,
    required: true,
  },
  moneyLine1x2AwayNo: {
    type: Array,
    required: true,
  },
  moneyLine1x2HomeYes: {
    type: Array,
    required: true,
  },
  moneyLine1x2HomeNo: {
    type: Array,
    required: true,
  },
  moneyLine1x2DrawYes: {
    type: Array,
    required: true,
  },
  moneyLine1x2DrawNo: {
    type: Array,
    required: true,
  },
  moneyLineAwayRiskWin: {
    type: Object,
    required: true,
  },
  moneyLineHomeRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2AwayYesRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2AwayNoRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2HomeYesRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2HomeNoRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2DrawYesRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2DrawNoRiskWin: {
    type: Object,
    required: true,
  },
  moneylineRisk: {
    type: Object,
    required: true,
  },
  moneyline1x2Risk: {
    type: Object,
    required: true,
  },
  avgOddsMoneyLine: {
    type: Number,
    required: true,
  },
  avgOddsMoneyLine1x2: {
    type: Number,
    required: true,
  },
  avgOddsSpreads: {
    type: Number,
    required: true,
  },
  avgOddsTotal: {
    type: Number,
    required: true,
  },
  totalRisk: {
    type: Object,
    required: true,
  },
  spreadRisk: {
    type: Object,
    required: true,
  },
  groupedBets: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    default: '',
  },
  league: {
    type: String,
    default: '',
  },
});

function showsMarket(market) {
  return !props.betType || props.betType === market;
}
</script>

<style scoped lang="scss">
@use '@/scss/main.scss';
</style>
